export default "__VITE_ASSET__CJJK0wui__"